var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#193a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "194b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#194b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CD0B20",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB00",
    fillRule: "evenodd",
    d: "M0 4.266h22v7.466H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B47C",
    fillRule: "evenodd",
    d: "M9.429 6.636v2.688c0 .746-.704 1.344-1.572 1.344H5.762c-.865-.002-1.572-.603-1.572-1.346V6.634c0-.61.47-1.12 1.115-1.286.195-.554.794-.057 1.504-.057.715 0 1.31-.494 1.505.058.643.17 1.115.68 1.115 1.287",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    fillRule: "evenodd",
    d: "M9.429 7.465h1.047v3.2H9.43zm-6.286 0h1.048v3.2H3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#165C96",
    fillRule: "evenodd",
    d: "M9.429 9.602h1.047v1.066H9.43zm-6.286 0h1.048v1.066H3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0790A",
    fillRule: "evenodd",
    d: "M9.429 6.398h1.047v1.067H9.43zm-6.286 0h1.048v1.067H3.143z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D20636",
    fillRule: "evenodd",
    d: "M5.238 6.398h1.048v1.6H5.238zm2.096 2.134H8.38v1.6H7.334z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A18793",
    fillRule: "evenodd",
    d: "M7.334 6.398H8.38v1.6H7.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE100",
    fillRule: "evenodd",
    d: "M5.238 8.535h1.048v1.6H5.238z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6161A",
    fillRule: "evenodd",
    d: "M6.286 6.399 5.238 5.332h3.143L7.334 6.399z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC9300",
    fillRule: "evenodd",
    d: "M6.286 4.266h1.047v1.066H6.286z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "193a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagEs = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagEs);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";